import { render, staticRenderFns } from "./AnimateScrollText.vue?vue&type=template&id=59791113&"
import script from "./AnimateScrollText.vue?vue&type=script&lang=ts&"
export * from "./AnimateScrollText.vue?vue&type=script&lang=ts&"
import style0 from "./AnimateScrollText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports